<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<h4 class="text-center" mat-dialog-title>
  <span i18n="@@autopsy">Autopsy</span> - <span class="text-uppercase font-extra-bold">{{autopsy?.tag}}</span>
</h4>

<div mat-dialog-content>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
    <p>
      <ng-container i18n="@@askingAutopsy">You are asking for an autopsy</ng-container>&nbsp;
      <ng-container><span class="text-uppercase font-extra-bold">{{autopsy?.tag}}</span></ng-container>
      ,&nbsp;
      <ng-container i18n="@@autopsySTD" *ngIf="isSTD">
        this will be done after the collection. Thank you for taking the necessary steps with your veterinarian.
      </ng-container>
      <ng-container i18n="@@autopsyGRO" *ngIf="isGRO">
        thank you to put the document provided by your insurance with the passport of the beast.
      </ng-container>
    </p>
  </div>
</div>

<div mat-dialog-actions>
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
    <button class="btn btn-danger btn-rounded btn-block" (click)="close(false)" i18n="@@cancel">Cancel</button>
  </div>

  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3">
    <button class="btn btn-secondary btn-rounded btn-block" (click)="close(true)" i18n="@@validate">Validate</button>
  </div>
</div>
